import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Platform',
    href: '#platform'
  }, {
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'Trust & Compliance',
    href: '#compliance'
  }, {
    name: 'Grants',
    href: '#grants'
  }, {
    name: 'Insights',
    href: '#insights'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-iris-black/90 backdrop-blur-md border-b border-iris-border py-3' : 'bg-transparent py-5'}`} style={{
    marginTop: isScrolled ? '0' : 'env(safe-area-inset-top)'
  }} data-id="element-218">
      <Container className="flex items-center justify-between" data-id="element-219">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group" data-id="element-220">
          <div className="w-8 h-8 bg-iris-green flex items-center justify-center relative overflow-hidden" data-id="element-221">
            <div className="absolute inset-0 border-2 border-iris-black transform rotate-45 scale-110 group-hover:rotate-90 transition-transform duration-500" data-id="element-222"></div>
            <span className="font-display font-bold text-iris-black text-xl relative z-10" data-id="element-223">
              I
            </span>
          </div>
          <span className="font-display font-bold text-2xl tracking-widest text-white" data-id="element-224">
            IRIS
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-225">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-mono text-iris-muted hover:text-iris-greenLight transition-colors uppercase tracking-wider" data-id="element-226">
              {link.name}
            </a>)}
        </nav>

        {/* CTA & Mobile Toggle */}
        <div className="flex items-center gap-4" data-id="element-227">
          <Button size="sm" className="hidden sm:flex" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-228">
            Schedule a Demo
          </Button>
          <button className="md:hidden text-iris-text p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-229">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-230" /> : <MenuIcon className="w-6 h-6" data-id="element-231" />}
          </button>
        </div>
      </Container>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-iris-surface border-b border-iris-border p-4 md:hidden flex flex-col gap-4 shadow-2xl" data-id="element-232">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-mono text-iris-text hover:text-iris-green p-2 border-b border-iris-border/50 uppercase tracking-wider" onClick={() => setMobileMenuOpen(false)} data-id="element-233">
              {link.name}
            </a>)}
          <Button className="w-full mt-2" onClick={() => {
        setMobileMenuOpen(false);
        document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-234">
            Schedule a Demo
          </Button>
        </div>}
    </header>;
}